/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskPoliciesGet } from "../funcs/riskPoliciesGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskPolicy } from "../models/components/riskpolicy.js";
import {
  GetRiskPolicyRequest,
  GetRiskPolicySecurity,
} from "../models/operations/getriskpolicy.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskPoliciesGetQueryData = RiskPolicy;

export function prefetchRiskPoliciesGet(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetRiskPolicyRequest,
  security?: GetRiskPolicySecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskPoliciesGetQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskPoliciesGetQuery(
  client$: GramCore,
  request: GetRiskPolicyRequest,
  security?: GetRiskPolicySecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RiskPoliciesGetQueryData>;
} {
  return {
    queryKey: queryKeyRiskPoliciesGet({
      id: request.id,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function riskPoliciesGetQueryFn(
      ctx,
    ): Promise<RiskPoliciesGetQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskPoliciesGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskPoliciesGet(
  parameters: {
    id: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "policies", "get", parameters];
}
